import "popper.js"
import "bootstrap/js/dist/util"
import "bootstrap/js/dist/collapse"
import "bootstrap/js/dist/dropdown"
import "slick-carousel"
import Vue from "vue"
import { debounce } from "lodash"
import {
  extend,
  localize,
  ValidationObserver,
  ValidationProvider
} from "vee-validate"
import * as rules from "vee-validate/dist/rules"
import en from "vee-validate/dist/locale/en.json"
import Forms from "./components/forms"
import Scroller from "./components/scroller"
import RangeSlider from "./components/RangeSlider.vue"
import FormOne from "./components/FormOne.vue"
import FormHome from "./components/FormHome.vue"
import FormBadCredit from "./components/FormBadCredit.vue"
import FormRemortgages from "./components/FormRemortgages.vue"
import FormSelfEmployed from "./components/FormSelfEmployed.vue"
import FormLet from "./components/FormLet.vue"
import FormDeposits from "./components/FormDeposits.vue"

Object.keys(rules).forEach(rule => {
  extend(rule, rules[rule])
})

extend("tel", {
  validate: value => {
    const regex = new RegExp("(?:\\+?44)[0-9]{9,10}|(?:0)[0-9]{10}")
    const phone = value.trim().replace(/ /g, "")

    return regex.test(phone) && regex.exec(phone)[0] === phone
  },
  message: field =>
    `The ${field} is not in valid format. Phone has to start with 0 or +44 and contain 9-10 numbers`
})

extend("postcode", {
  validate: value =>
    new RegExp(
      "^(([Gg][Ii][Rr] 0[Aa]{2})|((([A-Za-z][0-9]{1,2})|(([A-Za-z][A-Ha-hJ-Yj-y][0-9]{1,2})|(([A-Za-z][0-9][A-Za-z])|([A-Za-z][A-Ha-hJ-Yj-y][0-9]?[A-Za-z]))))\\s?[0-9][A-Za-z]{2}))$"
    ).test(value.trim()),
  message: () => "Please enter a valid postcode."
})

localize({ en })
Vue.component("ValidationProvider", ValidationProvider)
Vue.component("ValidationObserver", ValidationObserver)
Vue.prototype.$currency = window.App.currency

class App {
  static init() {
    new Forms().init()
    new Scroller().watch()

    new Vue({
      components: {
        RangeSlider,
        FormOne,
        FormHome,
        FormBadCredit,
        FormRemortgages,
        FormSelfEmployed,
        FormLet,
        FormDeposits
      }
    }).$mount("#app")

    $("section.hero-v2-logos .slick-slider").slick({
      variableWidth: true,
      arrows: false,
      infinite: true,
      dots: false
    })

    $(window).on(
      "scroll",
      debounce(() => {
        const $bar = $("section.sticky-cta")
        const isOnBottom =
          $(document).scrollTop() + $(window).height() >=
          $(document).height() - $(window).height() / 2
        const isOnTop = $(document).scrollTop() < $(window).height() / 2
        $bar.toggleClass("hide", isOnBottom || isOnTop)
      }, 50)
    )
  }
}

App.init()
